export const payrollDashboardOption = {
	name: [
		{ value: 76, label: "Total Staff" },
		{ value: 12, label: "Reception" },
		{ value: 30, label: "Nursing Male" },
		{ value: 40, label: "Nursing Female" },
		{ value: 26, label: "Security Gaurd" },
		{ value: 65, label: "Ward Aaya" },
		{ value: 63, label: "Ward Boy" },
		{ value: 45, label: "House Keeping" },
		{ value: 55, label: "IT Department" },
	],
	title: "Payroll Dashboard",
};
